module.exports = __webpack_public_path__ + "static/media/java.4eb1819d.png";